import { Direction } from '../../../utils/enum';

export const MERGE_PICTURE_DEFAULT_PADDING = 25;

export function paintCombinedImageOnCanvas({
  imageObj1,
  imageObj2,
  direction = Direction.Vertical,
  resize = true,
  padding = MERGE_PICTURE_DEFAULT_PADDING,
}: {
  imageObj1: HTMLImageElement;
  imageObj2: HTMLImageElement;
  direction?: Direction;
  resize?: boolean;
  padding?: number;
}): HTMLCanvasElement {
  const ifVertical = (
    direction: Direction,
    verticalValue: number,
    horizontalValue: number,
  ): number =>
    direction === Direction.Vertical ? verticalValue : horizontalValue;
  const image1Sizes = getImageSizeValues(imageObj1, resize);
  const image2Sizes = getImageSizeValues(imageObj2, resize);
  const canvasWidth = ifVertical(
    direction,
    Math.max(image1Sizes.width, image2Sizes.width),
    image1Sizes.width + image2Sizes.width + padding,
  );
  const canvasHeight = ifVertical(
    direction,
    image1Sizes.height + image2Sizes.height + padding,
    Math.max(image1Sizes.height, image2Sizes.height),
  );
  const canvas = document.createElement('canvas');
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  const context = canvas.getContext('2d')!;
  context.beginPath();
  context.rect(0, 0, canvasWidth, canvasHeight);
  context.fillStyle = 'white';
  context.fill();
  context.drawImage(imageObj1, 0, 0, image1Sizes.width, image1Sizes.height);
  context.drawImage(
    imageObj2,
    ifVertical(direction, 0, image1Sizes.width + padding),
    ifVertical(direction, image1Sizes.height + padding, 0),
    image2Sizes.width,
    image2Sizes.height,
  );

  return canvas;
}

// Get height and width size so height <= 500 && width <= 800
function getImageSizeValues(
  imageElem: HTMLImageElement,
  resize?: boolean,
): {
  height: number;
  width: number;
} {
  if (!resize) return { height: imageElem.height, width: imageElem.width };
  let height = imageElem.height;
  let width = imageElem.width;
  if (height > 500) {
    const percentage = 100 - (500 / height) * 100;
    height = height - (height / 100) * percentage;
    width = width - (width / 100) * percentage;
  }
  if (width > 800) {
    const percentage = 100 - (800 / width) * 100;
    height = height - (height / 100) * percentage;
    width = width - (width / 100) * percentage;
  }
  return { height: Math.round(height), width: Math.round(width) };
}

/**
 * URL.revokeObjectURL the return url after usage to clean it up
 */
export function getDataObjectUrlFromSvgString(svgString: string) {
  const strokeSvgBlob = new Blob([svgString], {
    type: 'image/svg+xml',
  });
  return URL.createObjectURL(strokeSvgBlob);
}
